import { render, staticRenderFns } from "./task-detail.vue?vue&type=template&id=fac574ae"
import script from "./task-detail.vue?vue&type=script&lang=js"
export * from "./task-detail.vue?vue&type=script&lang=js"
import style0 from "./task-detail.vue?vue&type=style&index=0&id=fac574ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports